module.exports = __webpack_public_path__ + "static/one-req-many-res-1-77b9ead14888deb453954043dda92f05.png";